import React, {useState} from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Container } from '@material-ui/core'
import {
  Identificacao,
  Funcionamento,
  Residuo,
  Poluicao,
  Laudo,
  Informacao } from '../../components/steps'

import './styles.css';

const getSteps = () => ([
  {
    component: Identificacao,
    label: 'Identificacao',
    description: 'Identificação'
  },
  {
    component: Funcionamento,
    label: 'Funcionamento',
    description: 'Area de Funcionamento'
  },
  {
    component: Residuo,
    label: 'Residuo',
    description: 'Resíduos'
  },
  {
    component: Poluicao,
    label: 'Poluicao',
    description: 'Poluição'
  },
  {
    component: Informacao,
    label: 'Informacao',
    description: 'Informações'
  },
  {
    component: Laudo,
    label: 'Impressao',
    description: 'Impressão'
  },
]);

function Main({dispatch, funcao}) {
  const [data, setData] = useState();
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();


  const getStepComponent = (stepIndex) => {
    let CurrentStepComponent = steps[stepIndex].component;
    let CurrentStepLabel = steps[stepIndex].label;
    return <CurrentStepComponent  updateStepData={ stepData => handleDataChange(CurrentStepLabel, stepData)}/>;
  }

  const handleDataChange = (stepLabel, newData) => {
    setData({...data, ...{[stepLabel]: {...data[stepLabel], ...newData}}});
  }

  const handleNext = () => {
  if  (activeStep !== 5 ) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      window.print()
    }
  };

  const onSubmit = e => {
    handleNext();
    e.preventDefault();
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Container maxWidth="lg" style={{marginTop: 140}}>
      <form onSubmit={onSubmit}>
        <Stepper activeStep={activeStep} alternativeLabel className="no-print mobile-steps">
          {steps.map((step) => (
            <Step key={step}>
              <StepLabel>{step.description}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {getStepComponent(activeStep)}

        <div className="footer-button">
          <Button
            disabled={activeStep === 0}
            onClick={handleBack}
            className="no-print prev-button"
          >
            Voltar
          </Button>

          <Button type="submit" variant="contained" color="primary"
            className="no-print next-button">
            {activeStep === steps.length - 1 ? 'Imprimir' : 'Avançar'}
          </Button>
        </div>
      </form>
    </Container>
  );
}
export default Main;

